import 'zone.js';
import { enableProdMode, NgZone, ApplicationRef, provideZoneChangeDetection } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { singleSpaAngular } from 'single-spa-angular';
import { singleSpaPropsSubject } from './single-spa/single-spa-props';
import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import '@angular/compiler';

import 'src/styles.scss?ngGlobalStyle';

declare global {
  interface Window {
    singleSpaNavigate?: boolean;
  }
}

if (environment && environment.production) {
  enableProdMode();
}

if (typeof window !== 'undefined') {
  // Add general unhandled promise rejection handler
  window.addEventListener('unhandledrejection', (event) => {
    console.warn('Unhandled promise rejection caught in main.single-spa.ts:', event.reason);
    // Prevent it from being logged as an uncaught error
    event.preventDefault();
  });
}

// Custom Single SPA configuration for Angular standalone
let platformRef: ApplicationRef | null = null;

export const bootstrap = (props: any) => {
  return Promise.resolve();
};

export const mount = (props: any) => {
  singleSpaPropsSubject.next(props);
  
  // Crear el elemento contenedor si no existe
  const containerElement = document.getElementById('single-spa-application:@menu-asteric/headersite') || 
                          document.querySelector('[data-name="@menu-asteric/headersite"]') ||
                          document.body;
  
  // Crear el elemento del componente si no existe
  let appElement = document.querySelector('MenuAsteric-root');
  if (!appElement) {
    appElement = document.createElement('MenuAsteric-root');
    containerElement.appendChild(appElement);
  }
  
  return bootstrapApplication(AppComponent, {...appConfig, providers: [provideZoneChangeDetection(), ...appConfig.providers]}).then((ref) => {
    platformRef = ref;
    return ref;
  });
};

export const unmount = (props: any) => {
  if (platformRef) {
    platformRef.destroy();
    platformRef = null;
  }
  
  // Limpiar el elemento del DOM
  const appElement = document.querySelector('MenuAsteric-root');
  if (appElement && appElement.parentNode) {
    appElement.parentNode.removeChild(appElement);
  }
  
  return Promise.resolve();
};
